// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lazy-scroll-into-view {
    display: flex;
    align-items: center;
    justify-content: center;

    &.visible {
        display: contents;
    }
}`, "",{"version":3,"sources":["webpack://./app/Components/Commons/lazy-scroll-into-view/lazy-scroll-into-view.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".lazy-scroll-into-view {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    &.visible {\r\n        display: contents;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
